<template>
  <menu-grid :sections="sections"></menu-grid>
</template>
<script>
import MenuGrid from "../menu-grid/menu-grid.vue";

export default {
  name: "security-menu",
  components: {MenuGrid},
  data: () => ({
    sections: []
  }),
  props: {
    menuId: {
      type: Number,
      required: true
    },
  },
  async mounted() {
    const { data } = await axios.get(`/api/backoffice/navigation/menu/${this.menuId}`)
    this.sections = data
  }
}
</script>
<style scoped>

</style>